import React from "react";
import {Grid, withStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CustomSelect from "../../components/Select";
import IdFilter from "../../components/Filters/IdFilter";
import {connect} from "react-redux";
class Filters extends React.Component
{
    
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            type: props.type,
            state: props.state,
            site: props.site, 
            name: props.name
        }
    }
    
    reset() {
        this.setState({
            id: '',
            type: '',
            state: '',
            site: '',
            name: ''
        })
        this.props.reset()
    }
    
    filterBy(val, type) {
        this.setState({[type]: val});
        this.props.filterBy(val, type);
        
    }
    
    render() {

        const {sites} = this.props;
        const availSites = sites;
        return (
            <Grid container alignItems={'stretch'} direction={'row'} justify={'wrap'}>
                <Grid item xs={3} lg={3} md={3} sm={3}>
                    <Typography
                        component={'div'}
                        style={{marginBottom: '30px', fontSize: '2rem'}}
                    >
                        Список аккаунтов
                    </Typography>
                </Grid>
                <Grid item xs={1.2} lg={1.2} md={1.2} sm={1.2}>
                    <IdFilter  
                        onInput={(e) => {this.filterBy(e.target.value, 'id')}} 
                        value={this.state.id}
                    />
                </Grid>

                <Grid item xs={1.2} lg={1.2} md={1.2} sm={1.2}>
                    <IdFilter 
                        borderRadius={'0 0 0 0'} 
                        onInput={(e) => {this.filterBy(e.target.value, 'name')}} 
                        value={this.state.name}
                        label={"Имя"}
                    />
                </Grid>
                <Grid item xs={1.2} lg={1.2} md={1.2} sm={1.2}>
                    <CustomSelect
                        onChange={(val) => this.filterBy(val, 'site')}
                        name={'site'}
                        rowsPerPageOptions={availSites}
                        withLabel={true}
                        emptyName={'Все сайты'}
                        withEmpty
                        borderRadius={'0 0 0 0'}
                        label={'Сайт'}
                        width={'140px'}
                        type={'autocomplete'}
                        value={this.state.site}
                    />
                </Grid> 
                <Grid item xs={1.2} lg={1.2} md={1.2} sm={1.2}>
                    <CustomSelect
                        onChange={(val) => this.filterBy(val, 'state')}
                        name={'state'}
                        rowsPerPageOptions={['Активные', "Неактивные"]}
                        withLabel={true}
                        emptyName={'Все'}
                        withEmpty
                        borderRadius={'0 0 0 0'}
                        label={'Статус'}
                        width={'140px'}
                        value={this.state.state}
                    />

                </Grid>
                <Grid item xs={1.2} lg={1.2} md={1.2} sm={1.2}>
                    <CustomSelect
                        onChange={(val) => this.filterBy(val, 'type')}
                        name={'type'}
                        rowsPerPageOptions={['Чат', "Письма"]}
                        withLabel={true}
                        emptyName={'Все'}
                        withEmpty
                        borderRadius={'0 0 0 0'}
                        label={'Тип'}
                        width={'140px'}
                        value={this.state.type}
                    />
                </Grid>
                <Grid item xs={0.1} lg={0.1} md={0.1} sm={0.1}>
                    <Button
                        style={{borderRadius: '0 20px 20px 0', padding: '7.5px 14px', }}
                        variant={"contained"}
                        color={'default'}
                        onClick={() => {
                            this.reset()
                        }}
                        borderRadius={'0 20px 20px 0'}
                    >Сброс</Button>
                </Grid>
                <Grid item xs={3} lg={3} md={1.5} sm={3} justify={'wrap'}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{borderRadius: '50px',marginLeft:'15px',   fontSize: '0.9rem', width: '60%', color: '#fff'}}
                        onClick={this.props.onClickToAddNew}
                    >
                        Добавить аккаунт
                    </Button>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = store => {
    return {
        sites: store.Clients.sites
    }
}

export default connect(mapStateToProps)(Filters)